/**
 * Labstep
 *
 * @module components/ResourceTemplate/Preview
 * @desc Preview for resource template
 */

import { EntityPreview } from 'labstep-web/components/Entity/Preview';
import { ResourceTemplateLayoutLinks } from 'labstep-web/components/ResourceTemplate/LayoutLinks';
import type React from 'react';
import type { IResourceTemplatePreviewProps } from './types';

export const ResourceTemplatePreview: React.FC<
  IResourceTemplatePreviewProps
> = ({ resource, ...rest }) => (
  <EntityPreview
    entity={resource}
    bottom={
      <ResourceTemplateLayoutLinks
        resourceTemplate={resource}
        withRoute={false}
      />
    }
    {...rest}
  />
);
